module.exports = __webpack_public_path__ + "static/home-right-5c1d78396daa8295e1747c27d8d3fb6c.jpg";